import { render, staticRenderFns } from "./NewCalculator.vue?vue&type=template&id=525dbee0&"
import script from "./NewCalculator.vue?vue&type=script&lang=js&"
export * from "./NewCalculator.vue?vue&type=script&lang=js&"
import style0 from "./NewCalculator.vue?vue&type=style&index=0&id=525dbee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports